module.exports = __webpack_public_path__ + "img/icon_time.86d66b14.svg";